import { ref, reactive, computed, watch } from 'vue';

import ApiValidationError from 'JIX/errors/ApiValidationError.js';

import { __ } from 'JIX/gettext.js';

export function useFormValidation({ validation, onReset, onSubmit }) {
    const formEl = ref();
    const formData = reactive({});
    const wasValidated = ref(false);
    const customErrors = ref({});
    const backendErrors = ref({});
    const validationErrors = computed(() => {
        return { ...backendErrors.value, ...customErrors.value };
    });

    for (const fn of validation || []) {
        watch(formData, () => fn(formData, customErrors), { flush: 'sync' });
    }

    watch(() => validationErrors, () => {
        for (const el of formEl.value?.elements ?? []) {
            el.setCustomValidity(validationErrors.value[el.name] || '');
        }
    }, { deep: true, flush: 'sync' });

    async function submit() {
        wasValidated.value = true;
        backendErrors.value = {};
        if (formEl.value?.reportValidity()) {
            try {
                await onSubmit();
            } catch (err) {
                if (err instanceof ApiValidationError) {
                    for (const error of err.json.errors) {
                        if (error.field) {
                            backendErrors.value[error.field] ||= error.error_message === 1
                                ? 'Fejl i indtastning'
                                : (error.error_message || __('Feltet skal udfyldes'));
                        }
                    }
                } else {
                    throw err;
                }
            }
        }
    }

    function reset() {
        wasValidated.value = false;
        backendErrors.value = {};
        onReset?.();
    }

    return { formEl, formData, wasValidated, validationErrors, reset, submit };
}

export function validDateAfter(startField, endField) {
    return (formData, errors) => {
        if (formData[startField] && formData[endField] && formData[endField] < formData[startField]) {
            errors.value[endField] = 'Slutdato må ikke være før startdato';
        } else {
            delete errors.value[endField];
        }
    };
}
